export const facialRecognition = {
  'All right!': 'Tudo certo!',
  'We’ve confirmed your identity! You can keep enjoying a hair-free life with us!':
    'Confirmamos sua identidade! Você pode continuar a aproveitar uma vida livre de pelos conosco!',
  'Hi, {{name}}!': 'Olá, {{name}}!',
  'We identified {{count}} absence(s)/cancellation(s) in your recent appointments.':
    'Identificamos {{count}} falta(s)/cancelamento(s) nos seus últimos agendamentos.',
  'To keep scheduling with us, we need to confirm your identity through facial recognition. It only takes a few seconds.':
    'Para continuar agendando conosco, precisamos confirmar sua identidade através do reconhecimento facial. Leva só alguns segundos.',
  'The facial recognition confirms that it is you requesting this new appointment, and that you are aware of and agree to attend.':
    'O reconhecimento facial confirma que é você mesmo solicitando este novo agendamento, e que está ciente e de acordo em comparecer.',
  'Identity confirmed. Returning to complete the signature…':
    'Identidade confirmada. Voltando para concluir a assinatura…',
  Continue: 'Prosseguir',
};
